<template>
  <div id="app"
       @contextmenu.prevent>
    <router-view />
  </div>
</template>

<script>
import {setToken} from "@/utils/token/jwtService";
import * as req from "@/utils/request";

export default {
  name: 'App',
  data() {
    return {}
  },
  watch: {
    '$route'(to, from) {
      this.$nextTick(() => {
        const container = this.$el.querySelector('.bottom')
        if (container) {
          container.scrollTop = 0
        }
      })
    }
  },
  created() {
    // 页面加载完成时执行
    window.addEventListener('load', this.setRem)
    // 窗口大小改变时重新计算
    window.addEventListener('resize', this.setRem)
    // 检查 是否是注册模式
    let result = this.isRegistere()
    if (result) {
      // 微信重定向后开始调用登录
      if (result.login) {
        let sendData = {}
        sendData.data = {uuid: result.login}
        sendData.fn = this._weChatLoginFn
        sendData.vm = this
        req.Post('wechat/login', sendData)
        // return
      }
    }
    this.fetchCourseCategoryList()
  },
  methods: {
    // 获取课程分类列表
    fetchCourseCategoryList() {
      let sendData = {}
      sendData.data = {}
      sendData.fn = this._courseCategoryListFn
      sendData.vm = this
      req.Get('course/category/list', sendData)
    },

    // 课程分类列表回调函数
    _courseCategoryListFn(data) {
      console.log('课程分类列表:', data)
      if (!data) {
        this.$message.error('获取课程分类失败 NETWORK ERROR')
        return;
      }
      if (data.code === 200) {
        // 将数据存储到 global.categoryList
        this.global.categoryList = data.data || []
        console.log('课程分类数据已存储:', this.global.categoryList)
      } else {
        this.$message.error(data.message || '获取课程分类失败')
      }
    },
    // 微信重定向后开始调用登录
    _weChatLoginFn(data) {
      // console.log('微信重定向后开始调用登录', data)
      if (!data) {
        this.$message.error(data.message)
        return;
      }
      if (data.code === 200) {
        setToken(data.data)
        this.$router.push('/')
        this.$nextTick(function () {
          window.location.reload()
        })
        return
      }
      if (data.code === 600) {
        const h = this.$createElement;

        this.$notify({
          title: '提示',
          message: h('i', {style: ''}, data.message)
        });
        return;
      }
      // window.$message.error(data.message)
    },
    // 注册和登录 都依靠 微信重定向
    isRegistere() {
      const url = window.location.href; // 用全链接，别用 hash！
      if (!url.includes('?')) {
        return null;
      }

      // 拿 ? 后面的参数
      const search = url.split('?')[1] || '';
      const params = new URLSearchParams(search);
      const result = Object.fromEntries(params.entries());

      // 清除链接参数 ✅ 关键
      this.hideLinkParameters();

      return result;
    },

// 清除 URL 上的参数（真正能清掉！）
    hideLinkParameters() {
      // 拿到 # 前面的基础路径
      let baseUrl = window.location.origin + window.location.pathname;
      let hash = window.location.hash.split('?')[0]; // 只保留 #/xxx，丢掉 ? 后面的

      // 拼接干净的 URL
      let cleanUrl = baseUrl + hash;
      // 替换历史记录，真正清除参数
      window.history.replaceState({}, document.title, cleanUrl);
    },
    setRem() {
      const designWidth = 1920
      const designHeight = 1080
      /* 浏览器分辨率 */
      const currentWidth = window.innerWidth
      const currentHeight = window.innerHeight

      // 获取屏幕的原始分辨率（物理像素）
      // const screenWidth = screen.width // 屏幕宽度
      // const screenHeight = screen.height // 屏幕高度

      // 计算宽度和高度的比例
      const widthScale = currentWidth / designWidth
      const heightScale = currentHeight / designHeight

      // 取较小的比例，保证内容完全显示
      const scale = Math.min(widthScale, heightScale)
      // 或者取平均值，根据具体需求选择
      // const scale = (widthScale + heightScale) / 2;

      const baseFontSize = 100
      const rootFontSize = scale * baseFontSize
      document.documentElement.style.fontSize = rootFontSize + 'px'
    }
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
#app {
  -webkit-user-select: none;
  /*webkit浏览器*/
  -moz-user-select: none;
  /*火狐*/
  -ms-user-select: none;
  /*IE10*/
  user-select: none;
  width: 100vw;
  height: 100vh;
  background-color: #ecf1fc;
}
.el-message {
  font-size: 14px !important;
  padding: 10px 30px !important;
  min-width: 280px !important;
}

.el-message__icon {
  font-size: 24px !important;
}

.el-message__content {
  font-size: 14px !important;
}
</style>
